import React from "react";

interface ReviewTilteProps {
  textTitle: string;
}

export default function ReviewTitle({ textTitle }: ReviewTilteProps) {
  return <h1>{textTitle}</h1>;
}
